import { styled } from '@mui/material'
import MuiTab from '@mui/material/Tab'
import { Theme } from '@mui/material/styles/createTheme'
import { Palette, PaletteColor } from '@mui/material/styles/createPalette'
import { alpha } from '@mui/material/styles'
import { TabProps } from './Tab.types'

type CssProps = TabProps & { theme?: Theme }
const mainColor =
  (p: keyof Palette) =>
  ({ theme }: CssProps) =>
    (theme?.palette[p] as PaletteColor).main

export const Tab = styled(MuiTab)<TabProps>`
  padding: 11px 16px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.5px;
  color: ${({ theme }) => alpha(theme.palette.black.main, 0.54)};
  line-height: normal;

  &.Mui-selected {
    text-shadow: 0 0 0.25px currentColor;
  }

  &.MuiButtonBase-root {
    padding: 10px 16px 11px;
  }

  &:hover {
    &::after {
      content: '';
      overflow: hidden;
      pointer-events: none;
      position: absolute;
      z-index: 0;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: inherit;
      opacity: 0.05;
    }
    &.Mui-selected {
      &::after {
        opacity: 0.1;
      }
    }

    &.MuiTab-textColorPrimary {
      &::after {
        background-color: ${mainColor('secondary')};
      }
      &.Mui-selected::after {
        background-color: ${mainColor('primary')};
      }
    }

    &.MuiTab-textColorSecondary {
      &::after {
        background-color: ${mainColor('secondary')};
      }
      &.Mui-selected::after {
        background-color: ${mainColor('secondary')};
      }
    }
  }
`
